import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { Subject } from 'rxjs';
import { SubjectSubscriber } from 'rxjs/internal/Subject';


@Component({
    selector: 'form-save',
    template: `
    <button mat-button (disabled)="!valid"  (click)="doPostItem()">
      <mat-icon class="mat-18">done</mat-icon>Feito
    </button>
    <button mat-button (click)="doCancelItem()">
      <mat-icon class="mat-18">cancel</mat-icon>Canc
    </button>
`,
    styles: [``]
})
export class FormSaveComponent implements OnInit {
    @Input()
    valid:boolean=true;
    @Output()
    post:EventEmitter<any> = new EventEmitter<any>();
    @Output()
    cancel:EventEmitter<any> = new EventEmitter<any>();
    constructor() { }

    ngOnInit(): void { }
    doPostItem(){
        this.post.emit();
    }
    doCancelItem(){
        this.cancel.emit();
    }
}
